import { render, staticRenderFns } from "./ModalAdmissionOccurrence.vue?vue&type=template&id=08cb9c8e&"
import script from "./ModalAdmissionOccurrence.vue?vue&type=script&lang=js&"
export * from "./ModalAdmissionOccurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports